import {
    afterNextRender,
    Component,
    ElementRef,
    input,
    viewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Editor } from "@tiptap/core";
import Color from "@tiptap/extension-color";
import { Level } from "@tiptap/extension-heading";
import Highlight from "@tiptap/extension-highlight";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import { Table } from "@tiptap/extension-table";
import TableHeader from "@tiptap/extension-table-header";
import { TableRow } from "@tiptap/extension-table-row";
import TextAlign from "@tiptap/extension-text-align";
import { TextStyleKit } from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
import Youtube from "@tiptap/extension-youtube";
import StarterKit from "@tiptap/starter-kit";
import { Node } from "prosemirror-model";
import { Transaction } from "prosemirror-state";
import ImageResize from "tiptap-extension-resize-image";
import { ListKit } from "@tiptap/extension-list";
import { CustomTableCell } from "./table-cell.extension";

@Component({
    selector: "app-editor-viewer",
    templateUrl: "./editor-viewer.component.html",
    styleUrls: ["./editor-viewer.component.css"],
    imports: [CommonModule],
})
export class EditorViewer {
    content = input<string>("");
    editorRef = viewChild<ElementRef<HTMLElement>>("editorRef");
    public editor?: any;
    minHeight = input<string>("300px");

    constructor() {
        afterNextRender(() => {
            this.editor = new Editor({
                editable: false,
                element: this.editorRef()?.nativeElement,
                content: this.content(),
                extensions: [
                    StarterKit,
                    ListKit,
                    Underline,
                    // Image.configure({ allowBase64: false, inline: true }),
                    ImageResize.configure({ inline: true }),

                    Color,
                    TextStyleKit,
                    TextAlign.configure({
                        types: ["paragraph", "heading"],
                    }),
                    Highlight.configure({
                        multicolor: true,
                    }),
                    CustomTableCell,
                    Table.configure({ resizable: true }),
                    TableRow,
                    TableHeader,
                    Link.configure({
                        autolink: true,
                        defaultProtocol: "https",
                        linkOnPaste: true,
                        openOnClick: true,
                    }),
                    Youtube.configure({}),
                ],
            });
        });
    }
}
